import React, { Component } from 'react';

import Core from './../../../Core/Core'
import ErrorManager from '../../../Core/ErrorManager';


import Header from './../../Header';
import CarForm from './../../Car/CarForm';
import ErrorBoundary from '../ErrorBoundary';

class CarEdit extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "car" : {},
        };

        this.submit = this.submit.bind(this);
        this.handleRedux = this.handleRedux.bind(this);

        this.load(props.match.params.id);
    }

    componentDidMount()
    {
        document.title = "W-F: Edition d'une entrée";
    }

    load(id)
    {
        Core.Instance.Request(Core.Address+"Car/"+id, null, "GET")
        .then((data) => {
            if(data == null)
            {
                ErrorManager.Instance.Handle("Aucune voiture ne possède cet identifiant.");
                return;
            }
            this.setState({
                "car" : data 
            });
        });
    }

    handleRedux(event)
    {
        let car = this.state.car;
        car[event.target.name] = event.target.value;
        this.setState({
            "car" : car
        });
    }

    submit()
    {
        if(Object.getOwnPropertyNames(this.state.car).length <= 0)
        {
            ErrorManager.Instance.Error("Vous devez remplir le formulaire avant de pouvoir enregistrer.");
            return;
        }

        if(!Core.Instance.CheckForm(this))
            return;
        let car = this.state.car;
        //car.date_first_code = car.date_first_code != null ? car.date_first_code/1000 : null;
        //car.date_begin = car.date_begin != null ? car.date_begin/1000 : null;
        //car.date_delivery = car.date_delivery != null ? car.date_delivery/1000 : null;
        let request = null;
        request = Core.Instance.Request(Core.Address+"Car/"+car.id, car, "PUT");
        request.then((json) => {
            return Core.Instance.user.RegisterEdit(this.state.car.Client_id, "Edition d'un véhicule.");
        }).then(() => {
            //ErrorManager.Instance.Info("Les modifications ont bien été enregistrées.");
            Core.Instance.GoBackWithRefresh();
        });      
    }

    render()
    {
        return (
            <ErrorBoundary>
                <Header buttons={ [
                    <button className="btn btn-primary" onClick={ this.submit }><li className="fas fa-save"> </li> Enregistrer</button>
                ] } />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <div className="box m-3 p-3">
                                <h2><li className="fas fa-car"> </li> Edition d'un véhicule possédé</h2>
                                <hr />
                                <CarForm car={ this.state.car } onChange={ this.handleRedux } />
                            </div>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}
export default CarEdit;



// WEBPACK FOOTER //
// ./src/Components/Views/Car/CarEdit.js